export const getFullAthleteLocation = (athlete) => {
  if (athlete.city && athlete.state) {
    return `${athlete.city}, ${athlete.state}`;
  }
  return athlete.streetOne ? athlete.streetOne : '';
};
